<template>
    <div class="endTitle">
        <div class="boxs u-flex u-row-between">
            <div class="u-flex-column box-list" v-for="item in list" :key="item.name">
                <div class="color-white font-20 mb-10">{{ item.name }}</div>
                <a class="color-white font-14 mb-10" :href="items.href" v-for="items in item.child" :key="items.name">{{
                    items.name
                }}</a>
            </div>
        </div>
        <div class="u-flex u-row-center u-font-14 color-white" style="margin: 62px 0 30px;">
            <span v-for="(item, index) in spanList" :key="item.name"><a class="cursor color-white" :href="item.href">{{
                item.name
            }}</a><span v-if="index != spanList.length - 1">｜&nbsp;</span></span>
        </div>
        <div class="u-flex u-row-center u-font-14 color-white">Copyright 2005-2017 123.com版权所有 京ICP备2022034085号-1 渝B2-12134567 渝公安网备 1234567890号 互联网违法和不良信息举报电话：1234567 邮箱：123456.com</div>
    </div>
</template>

<script>
export default {
    name: 'footerCom',
    props: {

    },
    data() {
        return {
            list: [{
                name: '新手指南',
                child: [{
                    name: '注册流程',
                    href: 'http://global.aitrans.org.cn/old/forwardAction/forward_toRegisterProcess.do'
                }, {
                    name: '规则中心',
                    href: 'http://global.aitrans.org.cn/old/forwardAction/forward_toRuleDescription.do'
                }, {
                    name: '用户认证',
                    href: 'http://global.aitrans.org.cn/old/forwardAction/forward_toIdentification.do'
                }]
            }, {
                name: '我是客户',
                child: [{
                    name: '客户须知',
                    href: 'http://global.aitrans.org.cn/old/forwardAction/forward_toCustomerInstructions.do'
                }, {
                    name: '项目发布',
                    href: 'http://global.aitrans.org.cn/old/forwardAction/forward_toPublishProcess.do'
                }, {
                    name: '质量控制',
                    href: 'http://global.aitrans.org.cn/old/forwardAction/forward_toQuality.do'
                }]
            }, {
                name: '我是译员',
                child: [{
                    name: '译员须知',
                    href: 'http://global.aitrans.org.cn/old/forwardAction/forward_toInterpreterTips.do'
                }, {
                    name: '任务接受',
                    href: 'http://global.aitrans.org.cn/old/forwardAction/forward_toTranslationProcess.do'
                }, {
                    name: '稿酬明细',
                    href: 'http://global.aitrans.org.cn/old/forwardAction/forward_toRemuneration.do'
                }]
            }, {
                name: '爱译智能-PAT',
                child: [{
                    name: '软件功能介绍',
                    href: 'http://global.aitrans.org.cn/old/forwardAction/forward_toFunction.do'
                }, {
                    name: '在线视频教学',
                    href: 'http://global.aitrans.org.cn/old/forwardAction/forward_toSoftwareTranslation.do'
                }, {
                    name: '直接下载',
                    href: 'http://global.aitrans.org.cn/old/down/Aitrans-PAT 6.0.zip'
                }]
            }],
            spanList: [{
                name: '关于我们',
                href: 'http://global.aitrans.org.cn/old/forwardAction/forward_toTeam.do'
            }, {
                name: '联系方式',
                href: 'http://global.aitrans.org.cn/old/forwardAction/forward_toTeam.do'
            }, {
                name: '爱译智能-CAT',
                href: 'http://www.aitrans.net'
            }, {
                name: '支付方式',
                href: 'javascript:;'
            }, {
                name: '友情链接',
                href: 'http://www.aitrans.org'
            }, {
                name: '安全中心',
                href: 'http://global.aitrans.org.cn/old/forwardAction/forward_toSecurityCenter.do'
            },]
        }
    },
    methods: {

    }
}
</script>

<style scoped lang="scss">
.box-list {
    text-align: center;
    border-radius: 50%;
    height: 200px;
    padding-top: 10px;
    border: 1px solid #ddd;
    width: 200px;
}

.endTitle {
    margin-top: 50px;
    width: 100%;
    height: 448px;
    background: linear-gradient(180deg, #129cdc 0%, #000c9b 100%);

    .boxs {
        width: 1200px;
        margin: 0 auto;
        padding-top: 50px;
    }

    .endText {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
    }

    .endLine {
        width: 90%;
        margin: 30px auto;
        height: 1px;
        opacity: 0.5;
        border: 1px solid #ffffff;
    }
}
</style>
